export { default } from './useTablesSettings'
